export const locale = {
    lang: 'br',
    data: {
        'DEVICE': {
            'NAME': 'Device'
        },
        'NAV': {
            'DASHBOARD': 'Dashboard',
            'APPLICATIONS': 'Aplicações',
            'USER': 'Usuários',
            'JOB': 'Cargos',
            'INFRA': 'Grupos',
            'SETTING': 'Configurações',
            'SEARCH': "Buscar",
            'MODULE': {
                'TALKING': 'Deep Call',
                'USAGE': 'Usage',
                'INVENTORY': 'Inventory',
                'VOICEBIOMETRIC': 'Biometria de Voz',
                'GEO': 'Geolocalização',
                'REALTIME' : 'Usage',
                'VOICE_BIOMETRIC': 'Biometria de Voz'
            },
            'LICENCES': 'Licenças',
            'PROFILE': 'Profile',
            'RECORDS': 'Cadastros',
            'DEVICES': 'Devices',
            'BEEPS': 'Beeps',
            'VOICE_PHRASES': 'Frases',
            'EQUALIZER': 'Equalizadores',
            'OPPORTUNITY' : 'Oportunidades',
            'FLTUSER' : 'Parceiros'
            
        },        
        'REALTIME': {
            'REALTIME': 'Usage',
            'PRESENCE': 'Presence',
            'LIVE': 'Live',
            'ONLINE': 'Ligados',
            'OFFLINE': 'Desligados',
            'INCALL': 'Em Chamada',
            'INMUTE': 'Em Mudo',
            'HEADSETS': 'Headsets',
            'HEADSET': 'Headset'
        },
        'TALKING': {
            'TALKING': 'Deep Call',
            'HOME': 'Home',
            'SUMMARY': 'Totalizadores',
            'TEAM_MEMBERS': 'Usuários',
            'TARGET': 'Meta',
            'CALLS': 'Chamadas',
            'TOTAL_CALL_USER': 'TOTAL DE CHAMADAS POR USUARIO',
            'TOTAL_CALL_TIME': 'TEMPO TOTAL DE CHAMADAS',
            'TOTAL_SPEAK_TIME': 'TEMPO TOTAL FALADO',
            'TOTAL_MUTE_TIME': 'TEMPO TOTAL MUDO',
            'TOTAL_CALLS': 'TOTAL DE CHAMADAS',
            'LIVE': 'Live',
            'NAME': 'Usuário',
            'USER': 'Usuário',
            'SHORT': 'Curtas',
            'LONG': 'Longas',
            'SHORT_SING': 'Curta',
            'LONG_SING': 'Longa',
            'TMA': 'TMA',
            'TMF': 'TMF',
            'TMM': 'TMM',
            'TTA': 'TTA',
            'TA': 'TA',
            'TF': 'TF',
            'TM': 'TM',
            'CALL_DETAIL': 'Timeline da Chamada',
            'PERIOD': 'Periodo',
            'MAP': 'Geolocalização'
        },
        'USAGE' : {
            'USAGE' : 'Usage',
            'USAGE_TIME' : 'Horas Ligado',
            'STATE_TIME' : 'Tempo',
            'CALL_TIME' : 'Horas Uso',
            'MUTE_TIME' : 'Horas Mudo',
            'DISCONNECTIONS' : 'Desconexões',
            'MODELS': 'MODELOS',
            'HEADSET_USED': 'HEADSETS UTILIZADOS',
            'DISCONNECTIONS_UPPER': 'DESCONEXÕES',
            'TOTAL_USER': 'HORAS DE USO POR USUARIO',
            'TOTAL_USAGE': 'HORAS LIGADO',
            'TOTAL_SPEAK': 'HORAS USO',
            'TOTAL_MUTE': 'HORAS MUDO',
            'ON' : 'Ligado',
            'CALL': 'Uso',
            'MUTE' : 'Mudo',
            'PAS': 'Computadores',
            'COMPUTER': 'Computador',
            'COMPUTERS': 'Computadores',
            'TOTAL_MODEL': 'HORAS DE USO POR MODELO',
            'TOTAL_USAGE_CALL': 'HORAS LIGADO / USO / MUDO',
            'CONTROL_TIME': 'Control',
            'HEADSET_TIME': 'Headset',
            'TOTAL_COMPUTER': 'HORAS DE USO POR COMPUTADOR',
            'HEAD_ON' : 'Heads Ligados',
            'HEAD_OFF' : 'Heads Desligados',
            'HEAD_IN_USE' : 'Heads em Uso',
            'INACTIVE': 'Inativas'

        },
        'INVENTORY' : {
            'INVENTORY' : 'Inventory',
            'HEADSETS' : 'Headsets',
            'ACTIVE' : 'Ativos',
            'INACTIVE' : 'Inativos',
            'OUT_OF_SERVICE' : 'Sem Uso',
            'CONNECTED' : 'Conectados',
            'DISCONNECTED' : 'Desconectados',
            'DISCONNECTIONS' : 'Desconexões',
            'MODELS': 'MODELOS UTILIZADOS',
            'HEADSET_USED': 'HEADSETS UTILIZADOS',
            'TOTAL_USAGE': 'TEMPO UTILIZACAO',
            'DISCONNECTIONS_UPPER': 'DESCONEXÕES',
            'PRODUCT_NAME': 'Modelo',
            'SERIAL': 'Serial',
            'HEADSET_STATUS': 'Status',
            'HEADSET_FIRST_CONN': 'Inicio',
            'HEADSET_LAST_CONN': 'Ultimo Acesso',
            'USER_NAME': 'Usuario',
            'COMPUTER_NAME': 'Desktop',
            'INFRA_NAME': 'Infra',
            'HEADSET_MODEL': 'HEADSETS POR MODELO',
            'HEADSET_ACTIVE': 'ATIVOS / INATIVOS / SEM USO',
            'MANUFACTURER': 'Fabricante',
            'QTD': 'Qtd',
            'USAGE': 'Uso',
            'WARRANTY_STATUS': 'Garantia'
        },
        'BUTTONS': {
            'DELETE': 'EXCLUIR',
            'SAVE': 'SALVAR',
            'ADD': 'ADICIONAR'
        },
        'SETTINGS': {
            'SETTINGS': 'Configurações',
            'INVENTORY': 'Inventário',
            'USAGE': 'Uso',
            'BEEP_MUTE_ALLERT': 'Beep do Alerta do Mudo',
            'MODULES': 'Módulos',
            'NAME': 'Nome',
            'EDIT': 'Editar Configuração',
            'NEW': 'Nova Configuração',
            'SOFTPHONE': 'Softphone',
            'SOUNDS': 'Sons',
            'BEEP_VOLUME': 'Beep do Volume',
            'BEEP_MUTE_ON': 'Beep do Mute On',
            'BEEP_MUTE_OFF': 'Beep do Mute Off',
            'AUDIO' : 'Audio',
            'GAIN_MIN': 'Ganho Minimo',
            'GAIN_MAX': 'Ganho Máximo',
            'MUTE': 'Mudo',
            'MUTE_ON': 'Mute Ligado',
            'MUTE_CONTROL': 'Controle de Mudo',
            'MAX_MUTE_TIME': 'Tempo Máximo de Mudo',
            'MUTE_ALLERT': 'Tempo de Alerta de Mudo',
            'CALLS': 'Chamadas',
            'TMA_TARGET': 'Meta do TMA',
            'TMM_TARGET': 'Meta do TMM',
            'SHORT_CALL': 'Chamadas Curtas',
            'LONG_CALL': 'Chamadas Longas',
            'INVENTORY_DAYS_ACTIVE': 'Inativar (em Dias)',
            'INVENTORY_DAYS_INACTIVE': 'Fora de Serviço (em Dias)',
            'TALKING': 'Talking',
            'STUDIO': 'Studio',
            'VOICE': 'Voice',
            'GENERAL': 'Geral',
            'PRESENCE_TIME': 'Tempo Presença',
            'GEO_TIME': 'Tempo Geolocalização',
            'NOISEOFF': 'Noise Off',
            'OUT_NOISE': 'Noise Off',
            'OUT_AUDIO': 'Studio',
            'OUT_BLOCK': 'Bloquear',
            'DISCONNECTIONS': 'Desconexões por Hora',
            'VOICE_VOICE_CONFIDENCE': 'Confidência da Voz',
            'VOICE_TEXT_CONFIDENCE': 'Confidência do Texto',
            'OUT_EFFECT': 'Efeito Padrão', 
            'PAS': 'Computadores',
            'ACTIVE': 'Ativos',
            'PENDING': 'Pendentes',
            'COMPANY': 'Empresa'
        },
        'INFRA': {
            'INFRA': 'Grupos',
            'NAME': 'Operação',
            'EDIT': 'Editar Operação',
            'NEW': 'Nova Operação',
            'NETWORK': 'Rede',
            'HOMEOFFICE': 'Home Office',
            'INLOCO': 'In Loco',
            'PAS': 'Computadores',
            'CONFIGURATED': 'Configuradas',
            'UPDATED': 'Atualizadas'
        
        },
        'COMPUTER': {
            'EDIT': 'Alterar',
            'NAME': 'Computador',
            'POSITION': 'Posição',
            'HOMEOFFICE': 'Home Office',
            'SO': 'Sistema Operacional',
            'IP': 'IP',
            'MACADDRESS': 'MAC Address',
            'VERSION': 'Versão',
            'LICENCE': 'Licença',
            'DTH_LICENCE': 'Data de Expiração',
            'LASTLOGG' : 'Último Log    '
        },
        'AUDIO': {
            'AUDIO' : 'Audio'
            
        },
        'HEALTH' : {
            'HEALTH' : 'Health'
        }
        ,
        'CLONE' : {
            'CLONE' : 'Clone'
        }
        ,
        'USER': {
            'USER': 'Usuario'
        },
        'AGENT': {
            'NAME': 'Usuário',
            'USERNAME': 'Usuario',
            'DOMAIN': 'Dominio'
        },
        'GEO': {
            'MAP': 'Geolocalização',
            'ADDRESS': 'Endereco',
            'GEO': 'Geolocalizadas',
            'GEOLOCATION' : 'Geolocalizacao',
            'NOTLOCATION' : 'Não Localizadas'
        },
        'PROFILE': {
            'PROFILE': 'Profile',
            'LOCATION': 'Localizacao'
        },
        'VOICE_BIOMETRIC': {
            'VOICE_BIOMETRIC' : 'Biometria de Voz',
            'FINISHED': 'Cadastrados',
            'SUCCESS': 'Verificações Bem Sucedidas',
            'USERS': 'Usuários',
            'FAILS': 'Falhas na Verificação'
        }, 
        'LICENCE': {
            'LICENCES': 'Licenças',
            'NAME': 'Licença',
            'COMPANY': 'Empresa',
            'PHONE': 'Telefone',
            'LICENCE': 'Licenças',
            'USED': 'Usadas',
            'ACTIVE': 'Ativas',
            'EXPIRED': 'Expiradas',
            'EMAIL': 'E-mail',
            'LICENCEKEY': 'Chave',
            'LASTNAME': 'Sobrenome',
            'AVAILABLE': 'Disponíveis'
        }
    }
};
